import script from "./RequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsPage.vue?vue&type=script&setup=true&lang=js"

import "./RequestsPage.vue?vue&type=style&index=0&id=25ea46cc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ea46cc"]])

export default __exports__